'use strict';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-dialog/dist/css/bootstrap-dialog.min.css';
import 'font-awesome/css/font-awesome.min.css';
import 'flag-icon-css/css/flag-icon.css';
import "@fortawesome/fontawesome-free/css/all.css"; 
import 'ng-table/bundles/ng-table.css';
import 'angular-object-diff/dist/angular-object-diff.css';
import '../css/angular-csp.css';
import '../src/custom.css';

import '../js/other/psMathStats.js';


import * as angular from 'angular';
import 'angular-animate';
import 'angular-resource';
import 'angular-route';
import 'angular-clipboard';
import 'angular-confirm';
import 'angular-cookies';
import 'angular-dynamic-locale/dist/tmhDynamicLocale';
import 'angular-loader';
import 'angular-loading-bar';
import 'angular-marked';
import 'angular-ordinal';
import 'angular-sanitize';
import 'angular-translate';
import 'angular-translate-handler-log';
import 'angular-translate-loader-static-files';
import 'angular-translate-storage-cookie';
import 'angular-ui-bootstrap';
import 'angular-ui-calendar';
import 'angular-ui-layout';
import 'marked';
import 'moment';
import 'bootstrap-switch';
import 'ng-table/bundles/ng-table';
import 'fullcalendar';
import 'rx-angular';
import 'angular1-async-filter';
import 'oclazyload';
import 'angular-object-diff';
import 'angular-jsoneditor';
import 'ng-jsoneditor';
import 'bootstrap/dist/js/bootstrap.min.js';

(window as any).JSONEditor = require('jsoneditor');

import { nocRun } from './nocRun';
import { nocConfig } from './nocConfig';

import './downgradedAngularModule';

import './core/index';
import './login/index';
import './shared/index';
import './config/index';
import './train-schedule/index';
import './monitoring/index';
import './analysis/index';
import { downgradeComponent } from '@angular/upgrade/static';
import { AppComponent } from '../src/app/app.component';


export const appModuleAngularJS = angular.module('noc', [
    'noc.angular',
    'noc.analysis',
    'noc.core', 
    'noc.login',
    'noc.shared',
    'noc.config',
    'noc.trainSchedule',
    'noc.monitoring',
    'ngCookies', 
    'ngTable', 
    'ngAnimate',
    'ngSanitize', 
    'ui.bootstrap', 
    'pascalprecht.translate', 
    'tmh.dynamicLocale', 
    'ui.layout', 
    'ordinal', 
    'angular-clipboard', 
    'ui.calendar', 
    'angular-confirm', 
    'angular-loading-bar', 
    'hc.marked', 
    'rx',
    'asyncFilter',
    'ds.objectDiff'
])
.directive('appRoot', downgradeComponent({component: AppComponent}) as angular.IDirectiveFactory)
.run(nocRun)
.config(nocConfig);


